<script setup lang="ts">
import DeviceMock from "@/modules/landing/components/DeviceMock.vue";
import vReveal from "@/application/directives/vReveal";

const meta = [
  { color: "accent-blue", label: "Ledenportaal" },
  { color: "accent-orange", label: "Bestuursoverzicht" },
  { color: "accent-green", label: "Eigen omgeving per club" },
];
</script>

<template>
  <section id="top" class="hero">
    <VContainer class="landing-container">
      <VRow justify="center">
        <VCol v-reveal cols="12" md="9" lg="7" class="text-center">
          <p class="landing-eyebrow">Voor sportclubs &amp; verenigingen</p>
          <h1 class="landing-h1">
            Vrijwilligerstaken regelen zonder groepsapp-chaos.
          </h1>
          <p class="landing-lede mt-4 mx-auto">
            Leden melden zich online aan voor bardienst, EHBO, scheidsrechters
            of klussen. Klupz stuurt automatisch de bevestiging - en het bestuur
            ziet in één oogopslag wie wat doet, per seizoen.
          </p>

          <div class="d-flex justify-center mt-8">
            <VBtn
              color="primary"
              size="large"
              variant="flat"
              append-icon="$arrowRight"
              href="mailto:info@bytechnology.nl?subject=Demo%20Klupz%20aanvragen"
            >
              Demo aanvragen
            </VBtn>
          </div>

          <div class="d-flex flex-wrap justify-center ga-6 mt-8">
            <div
              v-for="item in meta"
              :key="item.label"
              class="d-flex align-center ga-2 hero__meta-item"
            >
              <span class="hero__dot" :class="`bg-${item.color}`" />
              {{ item.label }}
            </div>
          </div>
        </VCol>
      </VRow>

      <div v-reveal class="hero__visual">
        <DeviceMock
          variant="laptop"
          src="/screenshots/admin-portal.png"
          alt="Klupz taakagenda op een laptop"
          placeholder="Schermafbeelding admin-portal volgt"
        />
        <DeviceMock
          variant="phone"
          src="/screenshots/member-portal.png"
          alt="Klupz ledenportaal op een telefoon"
          placeholder="Schermafbeelding ledenportaal volgt"
        />
      </div>
    </VContainer>
  </section>
</template>

<style scoped lang="scss">
.hero {
  padding: 56px 0 40px;
}

.hero__meta-item {
  font-size: 13px;
  color: rgb(var(--v-theme-emphasis));
}

.hero__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}

.hero__visual {
  position: relative;
  min-height: 360px;
  margin-top: 40px;
}

@media (min-width: 600px) {
  .hero__visual {
    min-height: 520px;
  }
}

@media (min-width: 960px) {
  .hero__visual {
    min-height: 720px;
    margin-top: 56px;
  }
}
</style>
